import { useEffect, useState, type Dispatch, type SetStateAction } from 'react';
import { safeParseJson } from '../utils/safeParseJson';

const STORAGE_KEY = 'dg_dark_mode';

/**
 * Persists class `dark` on `<html>` and mirrors state to `localStorage` (roadmap §11.1).
 */
export function useDarkMode(): [boolean, Dispatch<SetStateAction<boolean>>] {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    if (typeof window === 'undefined') return false;
    const dark = safeParseJson<boolean | null>(localStorage.getItem(STORAGE_KEY), null);
    return dark ?? window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDarkMode);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(isDarkMode));
    } catch {
      /* ignore */
    }
  }, [isDarkMode]);

  return [isDarkMode, setIsDarkMode];
}
